module.exports = __webpack_public_path__ + "static/img/5.0b8cd9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/5.png
// module id = UhRj
// module chunks = 0